import React from "react";
import {
  Attachment3dModel,
  AttachmentImage,
  GalleryModal as GalleryModalUI,
  GalleryModalProps,
} from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { useDownloadFile } from "../hooks/useDownloadFile.js";

export const GalleryModal = <I extends AttachmentImage | Attachment3dModel>(
  props: GalleryModalProps<I>
) => {
  const { t } = useTranslate("Global");
  const { downloadFileFromUrl, downloading } = useDownloadFile();
  return (
    <GalleryModalUI
      downloadTitle={t("Download")}
      addTitle={t("Add")}
      rotateTitle={t("Rotate")}
      deleteTitle={t("Delete")}
      handleDownloadFileFromUrl={downloadFileFromUrl}
      downloading={downloading}
      {...props}
    />
  );
};
